import * as React from "react";
const SvgFiRrBookOpenReader = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-book-open-reader_svg__a)">
      <path
        fill="#062147"
        d="M12 9c5.934-.156 5.933-8.845 0-9-5.934.156-5.933 8.845 0 9m0-7c3.286.059 3.285 4.942 0 5-3.285-.059-3.285-4.942 0-5m10.204 9.162a5 5 0 0 0-4.099-1.081l-3.821.695A4 4 0 0 0 12 12.065a4 4 0 0 0-2.285-1.289l-3.821-.695a5 5 0 0 0-4.098 1.081A4.99 4.99 0 0 0 0 15.001v2.793a5 5 0 0 0 4.106 4.919l6.284 1.143a9 9 0 0 0 3.219 0l6.285-1.143a5 5 0 0 0 4.105-4.919v-2.793a4.98 4.98 0 0 0-1.796-3.838zM11 21.929a7 7 0 0 1-.252-.041l-6.284-1.143A3 3 0 0 1 2 17.793V15c0-.892.393-1.731 1.078-2.303a3 3 0 0 1 2.459-.648l3.821.695c.952.173 1.642 1 1.642 1.968zm11-4.135a3 3 0 0 1-2.463 2.952l-6.285 1.143a7 7 0 0 1-.252.041v-7.217c0-.967.69-1.795 1.642-1.968l3.821-.695A3 3 0 0 1 22 15.001z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-book-open-reader_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBookOpenReader;
